import { modulePermissionsNames } from "./modulePermissionsNames";

export default {
  [modulePermissionsNames.SET_PERMISSIONS](state: any, payload: any) {
    state.commit(modulePermissionsNames.SET_PERMISSIONS, payload);
  },
  [modulePermissionsNames.SET_PERMISSIONS_OBJ](state: any, payload: any) {
    state.commit(modulePermissionsNames.SET_PERMISSIONS_OBJ, payload);
  },
  [modulePermissionsNames.SET_PERMISSIONS_PAGE](state: any, payload: any) {
    state.commit(modulePermissionsNames.SET_PERMISSIONS_PAGE, payload);
  },
};
